// ==========================================================================
// Photo Booth Power Calculator Logic (assets/calculator.js - v3)
// ==========================================================================

// --- Device Data (UPDATED with user research) ---
const deviceData = {
  printers: {
    DS620A: { idle: 0.5, inUse: 390, duration: 8.3 },
    DS820A: { idle: 0.5, inUse: 548, duration: 8.3 },
    RX1HS: { idle: 1, inUse: 290, duration: 12.4 },
    QW410: { idle: 5, inUse: 192, duration: 19 },
    P520L: { idle: 15, inUse: 600, duration: 12.8 },
    CS2: { idle: 1, inUse: 372, duration: 11 },
  },
  computers: {
    'Surface Pro 9 (i7)': { 'idle': 3, 'peak': 60, 'requiresPrintServer': false },
    'Surface Pro 9 (i5)': { 'idle': 3, 'peak': 60, 'requiresPrintServer': false },
    'Surface Pro 8 (i7)': { 'idle': 3, 'peak': 63, 'requiresPrintServer': false },
    'Surface Pro 8 (i5)': { 'idle': 3, 'peak': 63, 'requiresPrintServer': false },
    'Surface Pro 7 (i7)': { 'idle': 4.8, 'peak': 50, 'requiresPrintServer': false },
    'Surface Pro 7 (i5)': { 'idle': 6, 'peak': 63.5, 'requiresPrintServer': false },
    'Surface Pro 6 (i7)': { 'idle': 3, 'peak': 44, 'requiresPrintServer': false },
    'Surface Pro 6 (i5)': { 'idle': 4, 'peak': 44, 'requiresPrintServer': false },
    'iPad Pro 12.9-inch (Gen 1)': { 'idle': 2, 'peak': 12, 'requiresPrintServer': true },
    'iPad Pro 9.7-inch (Gen 1)': { 'idle': 1, 'peak': 10, 'requiresPrintServer': true },
    'iPad Pro 12.9-inch (Gen 2)': { 'idle': 2, 'peak': 12, 'requiresPrintServer': true },
    'iPad Pro 10.5-inch (Gen 2)': { 'idle': 2, 'peak': 12, 'requiresPrintServer': true },
    'iPad Pro 11-inch (Gen 3)': { 'idle': 2, 'peak': 18, 'requiresPrintServer': true },
    'iPad Pro 12.9-inch (Gen 3)': { 'idle': 2, 'peak': 18, 'requiresPrintServer': true },
    'iPad Pro 11-inch (Gen 4)': { 'idle': 2, 'peak': 20, 'requiresPrintServer': true },
    'iPad Pro 12.9-inch (Gen 4)': { 'idle': 2, 'peak': 18, 'requiresPrintServer': true },
    'iPad Pro 11-inch (Gen 5)': { 'idle': 2, 'peak': 20, 'requiresPrintServer': true },
    'iPad Pro 12.9-inch (Gen 5)': { 'idle': 2, 'peak': 20, 'requiresPrintServer': true },
    'iPad Pro 11-inch (Gen 6)': { 'idle': 2, 'peak': 20, 'requiresPrintServer': true },
    'iPad Pro 12.9-inch (Gen 6)': { 'idle': 2, 'peak': 20, 'requiresPrintServer': true },
    'iPad Pro 11-inch (Gen 7)': { 'idle': 2, 'peak': 20, 'requiresPrintServer': true },
    'iPad Pro 13-inch (Gen 7)': { 'idle': 2, 'peak': 20, 'requiresPrintServer': true },
    'iPad Air (Gen 3)': { 'idle': 2, 'peak': 18, 'requiresPrintServer': true },
    'iPad Air (Gen 4)': { 'idle': 2, 'peak': 20, 'requiresPrintServer': true },
    'iPad Air (Gen 5)': { 'idle': 2, 'peak': 20, 'requiresPrintServer': true },
    'iPad Air 11-inch (Gen 6)': { 'idle': 2, 'peak': 20, 'requiresPrintServer': true },
    'iPad Air 13-inch (Gen 6)': { 'idle': 2, 'peak': 20, 'requiresPrintServer': true }
  },
  printServers: {
    'DNP WCM Plus connect module': { idle: 3, peak: 7 },
    'Mini PC (N100)': { idle: 6, peak: 34 },
    'Surface Pro 8 (i5)': { idle: 3, peak: 60 }, // Note: Same peak as computer data
    'Old Laptop (Generic)': { idle: 15, peak: 60 },
  },
};


// --- Main Initialization Function ---
function initializePowerCalculator(sectionId, bufferPercentSetting, efficiencyPercentSetting) {
  const container = document.querySelector(`[data-section-id="${sectionId}"]`);
  if (!container) { console.error(`Calculator container not found: ${sectionId}`); return; }

  const RECOMMENDED_BUFFER = 1 + (bufferPercentSetting / 100);
  const ASSUMED_EFFICIENCY = efficiencyPercentSetting / 100;

  const getEl = (id) => container.querySelector(`#${id}-${sectionId}`);

  // --- DOM Elements ---
  const form = getEl('power-calculator-form');
  const eventDurationInput = getEl('event-duration');
  const printerSelect = getEl('printer-select');
  const printerSpecsDiv = getEl('printer-specs');
  const printerIdleSpan = printerSpecsDiv?.querySelector('.printer-idle');
  const printerInUseSpan = printerSpecsDiv?.querySelector('.printer-in-use');
  const printerDurationSpan = printerSpecsDiv?.querySelector('.printer-duration');
  const printFrequencyInput = getEl('print-frequency');
  const printFrequencyUnitSelect = getEl('print-frequency-unit');
  const computerSelect = getEl('computer-select');
  const computerSpecsDiv = getEl('computer-specs');
  const computerIdleSpan = computerSpecsDiv?.querySelector('.computer-idle');
  const computerPeakSpan = computerSpecsDiv?.querySelector('.computer-peak');
  const computerCustomInputDiv = getEl('computer-custom-input');
  const computerCustomIdle = getEl('computer-custom-idle');
  const computerCustomPeak = getEl('computer-custom-peak');
  const computerUsageSlider = getEl('computer-usage-slider');
  const computerUsageValueSpan = getEl('computer-usage-value');
  const printServerSectionDiv = getEl('print-server-section');
  const printServerSelect = getEl('print-server-select');
  const printServerSpecsDiv = getEl('print-server-specs');
  const printServerIdleSpan = printServerSpecsDiv?.querySelector('.print-server-idle');
  const printServerPeakSpan = printServerSpecsDiv?.querySelector('.print-server-peak');
  const printServerCustomInputDiv = getEl('print-server-custom-input');
  const printServerCustomIdle = getEl('print-server-custom-idle');
  const printServerCustomPeak = getEl('print-server-custom-peak');
  const printServerUsageSlider = getEl('print-server-usage-slider');
  const printServerUsageValueSpan = getEl('print-server-usage-value');
  const flashSelect = getEl('flash-select');
  const flashCustomInputDiv = getEl('flash-custom-input');
  const flashCustomWattage = getEl('flash-custom-wattage');
  const flashPowerSlider = getEl('flash-power-slider');
  const flashPowerValueSpan = getEl('flash-power-value');
  const flashFrequencyInput = getEl('flash-frequency');
  const modelingLightWattageInput = getEl('modeling-light-wattage');
  const addDeviceBtn = getEl('add-device-btn');
  const additionalDevicesContainer = getEl('additional-devices-container');
  const totalPowerWhSpan = getEl('total-power-wh');
  const recommendedCapacitySpan = getEl('recommended-capacity');
  const resultDurationSpan = getEl('result-duration');
  const recommendedCapacityDisplaySpan = getEl('recommended-capacity-display');

  let additionalDeviceCount = 0;

  // --- Populate Dropdowns ---
  function populateDropdowns() {
    const populate = (selectElement, data) => {
        if (!selectElement) return;
        // Clear existing options except the first placeholder
        while (selectElement.options.length > 1) {
             if(selectElement.options[1].value !== "custom") { // Keep custom option if it exists
                 selectElement.remove(1);
             } else if (selectElement.options.length > 2) {
                 selectElement.remove(2); // Remove option after 'custom'
             } else {
                 break; // Only placeholder and custom left
             }
        }
        // Find if 'custom' option exists
        let customOption = null;
        if (selectElement.options.length > 1 && selectElement.options[1].value === "custom") {
            customOption = selectElement.options[1];
            selectElement.remove(1); // Temporarily remove custom option
        }

        // Add options from data
        Object.keys(data).sort().forEach(key => { // Sort keys alphabetically
            const option = document.createElement('option');
            option.value = key;
            option.textContent = key;
            selectElement.appendChild(option);
        });

        // Re-add custom option at the end if it existed
        if (customOption) {
            selectElement.appendChild(customOption);
        }
    };
    populate(printerSelect, deviceData.printers);
    populate(computerSelect, deviceData.computers);
    populate(printServerSelect, deviceData.printServers);
  }

  // --- Event Handlers ---
  printerSelect?.addEventListener('change', () => {
    const selectedPrinter = printerSelect.value;
    if (selectedPrinter && deviceData.printers[selectedPrinter] && printerSpecsDiv) {
      const specs = deviceData.printers[selectedPrinter];
      if(printerIdleSpan) printerIdleSpan.textContent = specs.idle;
      if(printerInUseSpan) printerInUseSpan.textContent = specs.inUse;
      if(printerDurationSpan) printerDurationSpan.textContent = specs.duration;
      printerSpecsDiv.style.display = 'block';
    } else if (printerSpecsDiv) {
      printerSpecsDiv.style.display = 'none';
    }
    // updateCalculations(); // Handled by form listener
  });

  computerSelect?.addEventListener('change', () => {
    const selectedComputerKey = computerSelect.value;
    let requiresServer = false;
    if (selectedComputerKey === 'custom') {
      if(computerSpecsDiv) computerSpecsDiv.style.display = 'none';
      if(computerCustomInputDiv) computerCustomInputDiv.style.display = 'block';
    } else if (selectedComputerKey && deviceData.computers[selectedComputerKey]) {
      const specs = deviceData.computers[selectedComputerKey];
      if(computerIdleSpan) computerIdleSpan.textContent = specs.idle;
      if(computerPeakSpan) computerPeakSpan.textContent = specs.peak;
      if(computerSpecsDiv) computerSpecsDiv.style.display = 'block';
      if(computerCustomInputDiv) computerCustomInputDiv.style.display = 'none';
      requiresServer = specs.requiresPrintServer === true;
    } else {
      if(computerSpecsDiv) computerSpecsDiv.style.display = 'none';
      if(computerCustomInputDiv) computerCustomInputDiv.style.display = 'none';
    }
    if (printServerSectionDiv) { printServerSectionDiv.style.display = requiresServer ? 'block' : 'none'; }
    // updateCalculations(); // Handled by form listener
  });

  printServerSelect?.addEventListener('change', () => {
     const selectedServerKey = printServerSelect.value;
     if (selectedServerKey === 'custom') {
         if(printServerSpecsDiv) printServerSpecsDiv.style.display = 'none';
         if(printServerCustomInputDiv) printServerCustomInputDiv.style.display = 'block';
     } else if (selectedServerKey && deviceData.printServers[selectedServerKey]) {
         const specs = deviceData.printServers[selectedServerKey];
         if(printServerIdleSpan) printServerIdleSpan.textContent = specs.idle;
         if(printServerPeakSpan) printServerPeakSpan.textContent = specs.peak;
         if(printServerSpecsDiv) printServerSpecsDiv.style.display = 'block';
         if(printServerCustomInputDiv) printServerCustomInputDiv.style.display = 'none';
     } else {
         if(printServerSpecsDiv) printServerSpecsDiv.style.display = 'none';
         if(printServerCustomInputDiv) printServerCustomInputDiv.style.display = 'none';
     }
     // updateCalculations(); // Handled by form listener
  });

  flashSelect?.addEventListener('change', () => {
      if(flashCustomInputDiv) flashCustomInputDiv.style.display = flashSelect.value === 'custom' ? 'block' : 'none';
      // updateCalculations(); // Handled by form listener
  });

  addDeviceBtn?.addEventListener('click', addDevice);

  // --- Centralized Input Listener ---
  form?.addEventListener('input', (event) => {
      if (event.target && (event.target.matches('input') || event.target.matches('select'))) {
          // Update slider displays
          if (event.target === computerUsageSlider && computerUsageValueSpan) computerUsageValueSpan.textContent = `${event.target.value}% Peak`;
          if (event.target === printServerUsageSlider && printServerUsageValueSpan) printServerUsageValueSpan.textContent = `${event.target.value}% Peak`;
          if (event.target === flashPowerSlider && flashPowerValueSpan) flashPowerValueSpan.textContent = `${event.target.value}%`;

          if (!event.target.closest('.recommendations-section')) updateCalculations();
      }
  });

   // Event delegation for dynamic devices
   additionalDevicesContainer?.addEventListener('change', (event) => {
       if (event.target.matches('.device-usage-pattern')) {
           const deviceDiv = event.target.closest('.additional-device');
           const intermittentOptions = deviceDiv?.querySelector('.intermittent-options');
           if(intermittentOptions) intermittentOptions.style.display = event.target.value === 'intermittent' ? 'block' : 'none';
       }
   });
    additionalDevicesContainer?.addEventListener('click', (event) => {
        if (event.target.matches('.remove-device-btn')) {
            event.target.closest('.additional-device')?.remove();
            updateCalculations();
        }
    });

  // --- Calculation Logic ---
  function calculateDeviceWh(idleW, peakW, usagePercent, durationHours) {
      let deviceWh = 0; idleW = parseFloat(idleW) || 0; peakW = parseFloat(peakW) || 0;
      usagePercent = parseFloat(usagePercent) || 0;
      if (peakW > idleW) {
          const peakTimeHours = durationHours * (usagePercent / 100);
          const idleTimeHours = durationHours - peakTimeHours;
          deviceWh = (peakW * peakTimeHours) + (idleW * idleTimeHours);
      } else { deviceWh = idleW * durationHours; }
      return deviceWh;
  }

  function calculateTotalWh() {
    let totalWh = 0;
    const durationHours = parseFloat(eventDurationInput?.value) || 0;
    if (durationHours <= 0) return 0;

    // 1. Printer
    const selectedPrinterKey = printerSelect?.value;
    if (selectedPrinterKey && deviceData.printers[selectedPrinterKey]) {
      const printer = deviceData.printers[selectedPrinterKey];
      const freq = parseFloat(printFrequencyInput?.value) || 0;
      const unit = printFrequencyUnitSelect?.value;
      const printsPerHour = unit === 'minute' ? freq * 60 : freq;
      const totalPrints = printsPerHour * durationHours;
      const printTimeTotalSeconds = totalPrints * printer.duration;
      const printTimeTotalHours = printTimeTotalSeconds / 3600;
      const idleTimeTotalHours = Math.max(0, durationHours - printTimeTotalHours);
      totalWh += (printer.inUse * printTimeTotalHours) + (printer.idle * idleTimeTotalHours);
    }

    // 2. Computer
    const selectedComputerKey = computerSelect?.value;
    let computerIdleW = 0, computerPeakW = 0;
    if (selectedComputerKey === 'custom') {
        computerIdleW = computerCustomIdle?.value; computerPeakW = computerCustomPeak?.value;
    } else if (selectedComputerKey && deviceData.computers[selectedComputerKey]) {
        computerIdleW = deviceData.computers[selectedComputerKey].idle; computerPeakW = deviceData.computers[selectedComputerKey].peak;
    }
    totalWh += calculateDeviceWh(computerIdleW, computerPeakW, computerUsageSlider?.value, durationHours);

    // 3. Print Server (Conditional)
    if (printServerSectionDiv?.style.display !== 'none') {
        const selectedServerKey = printServerSelect?.value;
        let serverIdleW = 0, serverPeakW = 0;
        if (selectedServerKey === 'custom') {
            serverIdleW = printServerCustomIdle?.value; serverPeakW = printServerCustomPeak?.value;
        } else if (selectedServerKey && deviceData.printServers[selectedServerKey]) {
            serverIdleW = deviceData.printServers[selectedServerKey].idle; serverPeakW = deviceData.printServers[selectedServerKey].peak;
        }
        totalWh += calculateDeviceWh(serverIdleW, serverPeakW, printServerUsageSlider?.value, durationHours);
    }

    // 4. Flash + Modeling
    let strobeMaxWattage = 0;
    if (flashSelect?.value === 'custom') {
        strobeMaxWattage = parseFloat(flashCustomWattage?.value) || 0;
    } else { strobeMaxWattage = parseFloat(flashSelect?.value) || 0; }

    if (strobeMaxWattage > 0) {
        const powerLevelPercent = parseFloat(flashPowerSlider?.value) || 100;
        const actualStrobeWattage = strobeMaxWattage * (powerLevelPercent / 100);
        const flashesPerMinute = parseFloat(flashFrequencyInput?.value) || 0;
        const flashesPerSecond = flashesPerMinute / 60;
        const avgStrobeWattageFactor = 0.01; // Simplified factor
        const referenceFrequency = 1 / 30;
        const scalingFactor = (flashesPerSecond > 0 && referenceFrequency > 0) ? (flashesPerSecond / referenceFrequency) : 0;
        const estimatedAvgStrobePower = actualStrobeWattage * avgStrobeWattageFactor * scalingFactor;
        if (estimatedAvgStrobePower > 0) totalWh += estimatedAvgStrobePower * durationHours;
    }
    const modelingWattage = parseFloat(modelingLightWattageInput?.value) || 0;
    if (modelingWattage > 0) totalWh += modelingWattage * durationHours;

    // 5. Additional Devices
    additionalDevicesContainer?.querySelectorAll('.additional-device').forEach(deviceDiv => {
        const idleW = deviceDiv.querySelector('.device-idle-w')?.value;
        const inUseW = deviceDiv.querySelector('.device-in-use-w')?.value;
        const usagePattern = deviceDiv.querySelector('.device-usage-pattern')?.value;
        const usagePercent = deviceDiv.querySelector('.device-usage-percent')?.value;
        let deviceWh = 0;
        if (usagePattern === 'continuous') { deviceWh = (parseFloat(inUseW) || parseFloat(idleW) || 0) * durationHours; }
        else { deviceWh = calculateDeviceWh(idleW, inUseW, usagePercent, durationHours); }
        totalWh += deviceWh;
    });

    return totalWh;
  }

  // --- Update Results ---
  function updateCalculations() {
    const totalWh = calculateTotalWh();
    const durationHours = parseFloat(eventDurationInput?.value) || 0;

    if(totalPowerWhSpan) totalPowerWhSpan.textContent = totalWh.toFixed(1);

    let recommendedWh = 0;
    if (totalWh > 0 && ASSUMED_EFFICIENCY > 0) {
        recommendedWh = (totalWh / ASSUMED_EFFICIENCY) * RECOMMENDED_BUFFER;
    }

    if(recommendedCapacitySpan) {
        const currentText = recommendedCapacitySpan.textContent;
        const newText = recommendedWh.toFixed(0);
        if (currentText !== newText) { // Only animate if value changed
            recommendedCapacitySpan.textContent = newText;
            recommendedCapacitySpan.classList.remove('result-updated');
            void recommendedCapacitySpan.offsetWidth; // Trigger reflow
            recommendedCapacitySpan.classList.add('result-updated');
        }
    }
    if(resultDurationSpan) resultDurationSpan.textContent = durationHours.toFixed(1);
    if(recommendedCapacityDisplaySpan) recommendedCapacityDisplaySpan.textContent = recommendedWh.toFixed(0);

    setTimeout(() => recommendedCapacitySpan?.classList.remove('result-updated'), 500);
  }

  // --- Add Device Function ---
  function addDevice() {
      additionalDeviceCount++;
      const div = document.createElement('div');
      div.classList.add('additional-device');
      div.dataset.deviceId = additionalDeviceCount;
      // Using unique IDs for labels/inputs in dynamic elements
      const devIdBase = `device-${sectionId}-${additionalDeviceCount}`;
      div.innerHTML = `
          <h4>Device #${additionalDeviceCount} <button type="button" class="remove-device-btn" title="Remove Device">&times;</button></h4>
          <label for="${devIdBase}-name">Name:</label>
          <input type="text" id="${devIdBase}-name" placeholder="e.g., LED Panel" class="additional-device-input device-name">
          <label for="${devIdBase}-idle">Idle Wattage:</label>
          <input type="number" id="${devIdBase}-idle" class="device-idle-w additional-device-input" min="0" step="0.1" value="0"> W
          <label for="${devIdBase}-in-use">In-Use Wattage:</label>
          <input type="number" id="${devIdBase}-in-use" class="device-in-use-w additional-device-input" min="0" step="0.1" value="0"> W
          <label for="${devIdBase}-pattern">Usage Pattern:</label>
          <select id="${devIdBase}-pattern" class="device-usage-pattern additional-device-input">
              <option value="continuous" selected>Continuous On</option>
              <option value="intermittent">Intermittent On/Off</option>
          </select>
          <div class="intermittent-options" style="display:none;">
            <label for="${devIdBase}-percent">Approx. % Time In-Use:</label>
            <input type="number" id="${devIdBase}-percent" class="device-usage-percent additional-device-input" min="0" max="100" value="50" step="5"> %
          </div>
      `;
      additionalDevicesContainer?.appendChild(div);
      updateCalculations();
  }

  // --- Initial Setup ---
  populateDropdowns();
  // Update initial slider displays
  if(computerUsageValueSpan && computerUsageSlider) computerUsageValueSpan.textContent = `${computerUsageSlider.value}% Peak`;
  if(printServerUsageValueSpan && printServerUsageSlider) printServerUsageValueSpan.textContent = `${printServerUsageSlider.value}% Peak`;
  if(flashPowerValueSpan && flashPowerSlider) flashPowerValueSpan.textContent = `${flashPowerSlider.value}%`;

  updateCalculations(); // Initial calculation
  setTimeout(() => recommendedCapacitySpan?.classList.remove('result-updated'), 500); // Remove initial animation class

} // End initializePowerCalculator